/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ActionDefinitionDtoMetaDataModel,
  ActionDefinitionDtoModel,
  ActionDefinitionMetaDataModel,
  ActionDefinitionModel
} from '@well/domain';
import {EnvironmentService} from "@irian-ro/util-environment";
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class ActionResourceService extends AbstractResourceService<ActionDefinitionModel, ActionDefinitionDtoModel, undefined, ActionDefinitionMetaDataModel> {

  constructor(protected httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('companyActionsUrl'), ActionDefinitionModel, undefined, undefined, undefined);
  }

  findAllForSubscriptionType(subscriptionTypeUuid: string,
          query?: any,
          additionalParams?: any): Observable<JsonApiResource<ActionDefinitionModel[], JsonApiListResourceMetadataBase>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    return this.httpClient.get(`${this.url}/list/${subscriptionTypeUuid}${queryString}`,{headers: this.headers}).pipe(this.mapToListOfObjects());
  }

  getTemplateFromSubscriptionUuid(subscriptionTypeUuid:string): Observable<JsonApiResource<ActionDefinitionDtoModel, ActionDefinitionDtoMetaDataModel>>{
    return this.httpClient.get<JsonApiResource<ActionDefinitionDtoModel, ActionDefinitionDtoMetaDataModel>>(`${this.url}/new/template/${subscriptionTypeUuid}`);
  }

}
